<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large">TSP Rate Procurement Report</legend>
  </div>
  <form id="carrierRateProcSearchGroup" role="form" [formGroup]="carrierRateProcSearchGroup">
  <div class="grid-row grid-gap-2">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label for="type" class="usa-label">Type</label>
      <select id="type" class="usa-select" formControlName='typeSelect'
              (change)="onSelectType($event.target.value)">
        <option value ='null' selected disabled>Choose one...</option>
        <option *ngFor="let typeSingle of searchTypes">{{typeSingle}}</option>
      </select>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label for="scacSelect" class="usa-label">SCAC</label>
      <select id="scacSelect" class="usa-select" formControlName='scacSelect'>
        <option *ngFor="let scacSingle of scacItems" [value]="scacSingle.value">{{scacSingle.name}}</option>
      </select>
    </div>
  </div>
  <div class="grid-row grid-gap-2">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label for="rateTypeSelect" class="usa-label">Rate Type</label>
      <select id="rateTypeSelect" class="usa-select" formControlName='rateTypeSelect' (change)="rateTypeChange($event.target.value)">
        <option *ngFor="let rateTypeSingle of rateTypeItems"
                [value]="rateTypeSingle.value">{{(rateTypeSingle.value === 'All') ? '': (rateTypeSingle.value + ' - ')}}  {{rateTypeSingle.name}}</option>
      </select>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label for="sroSelect" class="usa-label">SRO</label>
      <select id="sroSelect" class="usa-select" formControlName='sroSelect'>
        <option *ngFor="let sroSingle of sroItems" [value]="sroSingle.value">{{sroSingle.name}}</option>
      </select>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label for="rateCycleSelect" class="usa-label">Rate Cycle</label>
      <select id="rateCycleSelect" class="usa-select" formControlName='rateCycleSelect' (change)="onSelectRateCycle()">
        <option value ='null' selected disabled>Choose one...</option>
        <option *ngFor="let rateCycleSingle of rateCycleItems" [value]="rateCycleSingle.ratesBidcyclesId">
          {{rateCycleSingle.bidCycleName}} ( {{rateCycleSingle.rateEffectiveDate | date}}
          - {{rateCycleSingle.rateExpiryDate | date}} )
        </option>
      </select>
    </div>
  </div>
  <div class="grid-row margin-top-2">
    <button type="button" [disabled]='!this.carrierRateProcSearchGroup.valid' class="usa-button"
            (click)='generateReport(this.carrierRateProcSearchGroup.value)'>Generate
    </button>
  </div>
  </form>
  <div class="margin-top-2" *ngIf="noResults!==null">
   {{noResults}}
  </div>
  <div class="padding-top-4" *ngIf="noResults===null && carrierTypeProcListDetails && carrierTypeProcListDetails.length>0">
    <div>
      <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
        <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
      </svg>
      Right click on the report and select the appropriate options to export.
    </div>
    <div>
      <ag-grid-angular
      class="ag-theme-alpine"
      style="width: 100%;"
      [gridOptions]="carrierRateProcurementGridOptions"
      [rowData]="carrierTypeProcListDetails"
      [columnDefs]="carrerColumnDefs"
      [suppressDragLeaveHidesColumns]="true"
      ag-grid-resize>
    </ag-grid-angular>
    </div>
  </div>
</div>
